export enum SearchFacetsList {
  brand = 'BRANDS',
  points = 'POINTS',
  amenities = 'AMENITIES',
  propertyType = 'PROPERTY_TYPES',
  price = 'PRICE',
  activities = 'ACTIVITIES',
  cities = 'CITIES',
  states = 'STATES',
  countries = 'COUNTRIES',
  distance = 'DISTANCE',
  hotelType = 'HOTEL_SERVICE_TYPES',
  meetingEvents = 'MEETINGS_EVENTS',
  transportTypes = 'TRANSPORTATION_TYPES',
  leisureRegions = 'LEISURE_REGIONS',
  // breakfastAmenities = 'BREAKFAST_AMENTITIES'
  // leisureRegions = 'LEISURE_REGIONS',
  // rewardCategories = 'REWARDS_CATEGORIES',
  // states = 'STATES',
}

export enum SearchFacetsListCodes {
  brand = 'brands',
  points = 'points',
  amenities = 'amenities',
  propertyType = 'property-types',
  price = 'price',
  activities = 'activities-on-site',
  cities = 'cities',
  states = 'states',
  countries = 'countries',
  distance = 'distance',
  hotelType = 'hotel-service-types',
  meetingEvents = 'meetings-and-events',
  transportTypes = 'transportation-types',
  leisureRegions = 'leisure-region',
  // breakfastAmenities = 'BREAKFAST_AMENTITIES',
  // leisureRegions = 'LEISURE_REGIONS',
  // rewardCategories = 'REWARDS_CATEGORIES',
  // states = 'STATES',
}

export enum SearchSooSearchDestinationTypes {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  BOROUGH = 'BOROUGH',
  CITY = 'CITY',
  COUNTY = 'COUNTY',
  COUNTRY = 'COUNTRY',
  HOTEL_NAME = 'HOTEL_NAME',
  LEISURE_REGION = 'LEISURE_REGION',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  OTHERS = 'OTHERS',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  STATE = 'STATE',
}

export enum SearchGeographicDestinationTypes {
  Country = 'Country',
  State_Province_Region = 'State_Province_Region',
  Leisure_Region = 'Leisure Region',
}

export enum SearchWeekType {
  WEEKDAYS_ONLY = 'WEEKDAYS_ONLY',
  WEEKEND_ONLY = 'WEEKEND_ONLY',
  WEEKDAY_AND_WEEKEND_STAY = 'WEEKDAY_AND_WEEKEND_STAY',
}

export enum SearchDeviceType {
  DESKTOP_WEB = 'DESKTOP_WEB',
  MOBILE_WEB = 'MOBILE_WEB',
}

export enum SearchSooModelType {
  CONTROL = 'CONTROL',
  REVENUE_MAX = 'REVENUE_MAX',
  CONVERSION_MAX = 'CONVERSION_MAX',
  OUT_OF_SCOPE = 'OUT_OF_SCOPE',
}

export enum SearchBonvoyMemberLevel {
  ANONYMOUS = 'ANONYMOUS',
  BASIC = 'BASIC',
  GOLD = 'GOLD',
  SILVER = 'SILVER',
  PLATINUM = 'PLATINUM',
  PLATINUM_PREMIERE = 'PLATINUM_PREMIERE',
  TITANIUM = 'TITANIUM',
  AMBASSADOR = 'AMBASSADOR',
}

export enum SearchFacetsConstants {
  terms = 'terms',
  ranges = 'ranges',
  latitude = 'latitude',
  longitude = 'longitude',
  keyword = 'keyword',
  destination = 'destination',
  facets = 'facets',
  search = 'search',
  options = 'options',
  includeTaxes = 'includeTaxesAndFees',
  unavailableProperties = 'includeUnavailableProperties',
  limit = 'limit',
  offset = 'offset',
  goToNextPage = 'nextPage',
  sort = 'sort',
  points = 'pointsEnable',
  filter = 'filter',
  modes = 'modes',
  promote = 'promote',
  ids = 'ids',
  pointsRangeIndex = 'pointsRangeIndex',
  distanceRangeIndex = 'distanceRangeIndex',
  priceRangeIndex = 'priceRangeIndex',
  deviceType = 'deviceType',
  weekType = 'weekType',
  searchDestinationType = 'searchDestinationType',
  sooModel = 'sooModel',
  sooOptions = 'sooOptions',
  rewardsLevel = 'rewardsLevel',
  searchCity = 'searchCity',
  searchStateProvince = 'searchState',
  searchCountry = 'searchCountry',
}

export const SearchPageAlerts = {
  default: {
    code: '',
    heading: '',
    hasLink: false,
    linkUrl: '',
    linkText: '',
    errorMessage: '',
    showPageAndFilter: true,
    icon: '',
  },
  info: {
    code: '',
    heading: '',
    hasLink: false,
    linkUrl: '',
    linkText: '',
    errorMessage: "We're temporarily unable to display the information you requested. Please try again later.",
    showPageAndFilter: false,
    icon: 'icon-information',
    type: 'info',
  },
  warning: {
    code: 'queries.v2.properties.limit.range.dev.2',
    heading: '',
    hasLink: false,
    linkUrl: '',
    linkText: '',
    errorMessage:
      'There are too many hotels in your results to display pricing and availability information. Please further refine your search results.',
    showPageAndFilter: true,
    icon: 'icon-warning',
    type: 'warning',
  },
  success: {
    code: '',
    heading: 'Currency Updated',
    hasLink: false,
    linkUrl: '',
    // linkCallbackFunc: setDefaultPrice(),
    linkText: 'Show me rates in local currency',
    errorMessage: `When you reserve you will see the local currency of the hotel.`,
    showPageAndFilter: true,
    icon: 'icon-success',
    type: 'success',
  },
};

export const SearchSortFieldForCITY = ['CITY', 'BRAND', 'PROPERTY_NAME'];
export const SearchSortFieldForDISTANCE = ['DISTANCE', 'CITY', 'BRAND', 'PROPERTY_NAME'];
export const SearchSortFieldForBRAND = ['BRAND', 'PROPERTY_NAME'];

export enum SearchSortFields {
  brand = 'BRAND',
  distance = 'DISTANCE',
  price = 'PRICE',
  city = 'CITY',
  state = 'STATE',
  points = 'POINTS',
  guest_rating = 'GUEST_RATINGS',
  no_of_reviews = 'NUM_REVIEWS',
  default = 'PROPERTY_NAME',
}

export enum SearchSortFieldsDirection {
  desc = 'DESC',
  asc = 'ASC',
}

export const SortOptionCodeMapping: Record<string, { field: string; direction: string }> = {
  PRICE_ASC: { field: 'PRICE', direction: 'ASC' },
  PRICE_DESC: { field: 'PRICE', direction: 'DESC' },
  POINTS_ASC: { field: 'POINTS', direction: 'ASC' },
  POINTS_DESC: { field: 'POINTS', direction: 'DESC' },
};

export const ReverseSortOptionCodeMapping: Record<string, Record<string, string>> = {
  PRICE: { ASC: 'PRICE_ASC', DESC: 'PRICE_DESC' },
  POINTS: { ASC: 'POINTS_ASC', DESC: 'POINTS_DESC' },
};

export const SearchRangesEndPointArr = ['0', '100', '200', 'overflow'];
export const SearchDistanceRangesEndPointArr = ['0', '4830', '14520', '80470'];
export const filterList = [
  'BRANDS',
  'POINTS',
  'AMENITIES',
  'PROPERTY_TYPES',
  'PRICE',
  'ACTIVITIES',
  'CITIES',
  'STATES',
  'COUNTRIES',
  'DISTANCE',
  'HOTEL_SERVICE_TYPES',
  'MEETINGS_EVENTS',
  'TRANSPORTATION_TYPES',
];
export const SearchPointsEndPointArr = ['0', '40000', '80000', '120000', '160000', '200000', '240000', 'overflow'];
export const enableAverageNightlyRate = true;
export const RateNodeTypeToBeUsed = enableAverageNightlyRate
  ? 'lowest-average-nightly-rate'
  : 'first-night-lowest-stay';
export const unavailableCode = 'unavailable';
export const STATUS_NOT_AVAILABLE = 'NotAvailable';
export const HWSBrands = ['RZ', 'BCNRZ', 'DALIL', 'LISRZ'];
export const viewHotelWebsiteLink = '/hotels/travel/';
export const maxOccupancyCode = 'closedMaxOccupancyExceeded';
export const STATUS_MAX_OCCUPANCY_EXCEEDED = 'ClosedDueToMaxOcc';
export const RateNodeTypeToBeUsedInQuery = enableAverageNightlyRate
  ? 'LOWEST_AVERAGE_NIGHTLY_RATE'
  : 'FIRST_NIGHT_LOWEST_STAY';
export const PointsNodeTypeToBeUsedInQuery = 'POINTS_PER_UNIT';
export const PointsNodeTypeToBeUsed = 'points-per-unit';
export const DefaultCurrency = 'USD';
export const DefaultEURCurrency = 'EUR';
export const DefaultValue = 'default';
export const PRICE_CODE = 'standard';
export const STANDARD_RATES_CODE = 'StandardRates';
export const POINTS_CODE_VALUE = 'MRW';
export const SPECIAL_CODE = 'special';
export const SPECIAL_RATES_CODE = 'Special';
export const RATE_CATEGORY_MAPPER = {
  standard: 'StandardRates',
  special: 'Special',
};
export const AVAILABLE_CODE = 'available';
export const STATUS_AVAILABLE = 'AvailableForSale';
export const STATUS_MAPPER = {
  available: 'AvailableForSale',
  closedMaxOccupancyExceeded: 'ClosedDueToMaxOcc',
  unavailable: 'NotAvailable',
};
export const P17_CODE = 'P17';
export const EnableCurrencyPersistence = false;
export const STRIKE_PRICE_THRESHOLD_PERCENTAGE = 3.3;
export const descriptionToDisplayOnPropertyCard = 'HOTEL_MARKETING_CAPTION';
export const descriptionToDisplayOnPropertyCardChat = 'HOTEL MARKETING CAPTION';
export const descriptionFilterToDisplayOnPropertyCard = 'HOTEL_MARKETING_CAPTION';
export const resortDescriptionFilterToDisplayOnPropertyCard = 'RESORT_FEE_DESCRIPTION';
export const tourismMarketingToDisplayOnPropertyCard = 'TOURISM_MARKETING_FEE_DESCRIPTION';
export const destinationDescriptionFilterToDisplayOnPropertyCard = 'DESTINATION_FEE_DESCRIPTION';
export const LA_COUNTY_FEE_DESCRIPTION = 'SURCHARGE_ORDINANCE_COST_DESCRIPTION';
export const ALL_INCLUSIVE = 'all-inclusive';

//Recipe ID constants
export const OUTOFSCOPE = 'outOfScope';
export const CONTROL = 'control';
export const NOT_AVAILABLE = 'N/A';
export const NOT_AVAILABLE_RECIPE = '-N/A';

export const errorMessageRedirection = '../hotel-search.mi';
export enum MemberExclusiveBannerConstants {
  fourNights = 4,
  fiveNights = 5,
}

export const priceType = { code: 'standard', value: null };
export const pointsType = { code: 'special', value: 'MRW' };

export const dailyResortFeeLabel = 'Daily Resort Fee';
export const dailyDestinationFeeLabel = 'Daily Destination Fee';
export const clearAllFilterKey = 'clearAllFilters';
export const noNearAddressKey = 'noNearAddressPropertyResult';
export const noAvailabilityKey = 'noAvailabilityWithinRadius';
export const maxCapacityKey = 'noAvailabilityMaxcapacity';
export const noHotelsWithinRadiusKey = 'noHotelsWithinRadius';
export const invalidSearchPropertyResultKey = 'invalidSearchPropertResult';
export const unsuccessfulSellKey = 'unsuccessfulSellWarning';
export const showAvailabilityLabel = 'show available hotels';
export const showTaxesandFeesLabel = 'show taxes and fees';
export const tooManyPropertiesErrorKey = 'alertTooManyPropertiesNotification';
export const studioResCode = 'RS';
export const studisResCodeAriaLabel = 'Studio Rez';
export const alertRatesUnavailableWarning = 'alertRatesUnavailableWarning';
export const alertRedemptionAvailabilityNotificationKey = 'alertRedemptionAvailabilityNotification';
export const REDEMPTION_ALERT_SUPPORTED_LOCALES = ['en-US', 'en-GB'];
export const svgIcon = `
<svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73">
<!-- Outer black circle -->
<circle cx="36.5" cy="36.5" r="36.5" fill="black" opacity='0.1' />

<!-- Inner white circle -->
<circle cx="36.5" cy="36.5" r="25" fill="white" />
</svg>
`;

export const fallbackImages = {
  Classic: 'https://cache.marriott.com/is/image/marriotts7prod/bonvoy-error-image-10518:Classic-Hor',
  Square: 'https://cache.marriott.com/is/image/marriotts7prod/bonvoy-error-image-10518:Square',
  Wide: 'https://cache.marriott.com/is/image/marriotts7prod/bonvoy-error-image-10518:Wide-Hor',
  altText: 'Fallback',
};

export enum GraphQlAPiResponseKey {
  FLEXI_desti = 'searchPropertiesByDestination',
  FLEXI_geo = 'searchPropertiesByGeolocation',
  LAR_geo = 'searchLowestAvailableRatesByGeolocation',
  LAR_desti = 'searchLowestAvailableRatesByDestination',
  LAR_search_input = 'searchLowestAvailableRatesByLocation',
  FLEXI_by_id = 'searchPropertiesByIds',
  LAR_by_id = 'searchLowestAvailableRatesByPropertyIds',
}

export enum GraphQlMgpAPiResponseKey {
  geo = 'searchByGeolocation',
  desti = 'searchByDestination',
  search_input = 'searchByLocation',
  id = 'searchByPropertyIds',
}

export const mandatoryFeeCodes = {
  resortFeeCode: 'RESORT_FEE_DESCRIPTION',
  destinationFeeCode: 'DESTINATION_FEE_DESCRIPTION',
  resortFeeCheck: 'a resort fee of',
  destinationFeeCheck: 'a daily destination fee of',
  laCountyFeeCode: 'SURCHARGE_ORDINANCE_COST_DESCRIPTION',
  marketingFeeCode: 'TOURISM_MARKETING_FEE_DESCRIPTION',
  laCountyFeeCheck: 'Surcharge added for hotel costs to comply with LA Hotel Worker Protection Ordinance.',
};

export const amenityCodeToIconMap: Record<string, string> = {
  'EV Charging': 'ev-charging-station',
  'Whirlpool in Room': 'pool',
  'Whirlpool on Site': 'pool',
  'new-lobby': 'check',
  'member-lounge': 'lounge-access',
};

export const tooltipAmenities: Record<string, string> = {
  'member-lounge': 'memberLoungeTooltipLabel',
};

export const priorityPhotoCategoryCode = 'preferred';

export enum hardCodedAllLocale {
  de = 'de-DE',
  en = 'en-US',
  zhTW = 'zh-TW',
  ko = 'ko-KR',
  ar = 'ar-AE',
  hi = 'hi-IN',
}

// Image transition constants
export const croppingRatio = 6;
export const outputQuality = 90;
export const outputInterpolation = 'progressive-bilinear';

export const searchFilters = {
  amenities: 'amenities',
  transportationTypes: 'transportation',
  brands: 'marriottBrands',
  hotelTypes: 'hotelType',
  activities: 'activities',
  events: 'events',
  states: 'states',
  cities: 'cities',
  showAvailableHotels: 'showAvailableHotels',
  includeTaxes: 'showFullPrice',
  selectedCurrency: 'currency',
  view: 'view',
  distanceRangeIndex: 'distanceRangeIndex',
  priceRangeIndex: 'priceRangeIndex',
  pointsRangeIndex: 'pointsRangeIndex',
};

export const payloadCountryCodeForChina = 'CN, TW, MO, HK';
export const countryCodeForChina = 'CN';
export const destinationValueForChina = 'CHINA';
export const PLACE_ID_FOR_MACAU = 'ChIJ88g14uB6ATQR9qyFtCzje8Y';
export const PLACE_ID_FOR_HONG_KONG = 'ChIJD5gyo-3iAzQRfMnq27qzivA';
export const PLACE_ID_FOR_TAIWAN = 'ChIJL1cHXAbzbjQRaVScvwTwEec';

export const description = {
  resortFeeDescription: 'RESORT_FEE_DESCRIPTION',
  destinationFeeDescription: 'DESTINATION_FEE_DESCRIPTION',
  surchargeOrdinanceCostDescription: 'SURCHARGE_ORDINANCE_COST_DESCRIPTION',
};

export const dataLayerLabels = {
  points: 'POINTS',
  price: 'PRICE',
  distance: 'DISTANCE',
  brand: 'BRANDS',
  states: 'STATES',
};

export const RECOMMENDED_SORT = 'recommendedSort';
export const RECOMMENDED_OPTION = 'RECOMMENDED';
export const MARRIOTT_CACHE_URL = 'https://cache.marriott.com/';
export const DEFAULT_SORT_OPTS = 'no-segment-options';

export const DEFAULT_IMAGE =
  'https://cache.marriott.com/content/dam/marriott-digital/cy/us-canada/hws/h/hpnnb/en_us/logo/internal/assets/cy-hpnnb-grey-image-placeholder-34740.png?imbypass=on';

export const ALL_INCLUSIVE_CODE = 'all-inclusive';
export const ALL_INCLUSIVE_LABEL = 'All-Inclusive';

export const COUNTRY_LIST_SHOW_FULL_PRICE_BY_DEFAULT = ['NL', 'TH'];
export const G_MAP_PIXEL_OFFSET_X_CORD = -3;
export const G_MAP_PIXEL_OFFSET_Y_CORD = 4;

export const validErrorCodes = ['LAR-1001', 'LAR-1002', 'LAR-1003'];
export const validWarningCodes = [
  'LAR-1002',
  'AMP181',
  'queries.v2.properties.limit.range.dev.2',
  'WARN-SEARCH-1009',
  'WARN-SEARCH-1006',
  'WARN-RATES-1000',
  'WARN-SEARCH-1002',
  'WARN-RATES-1001',
];

export const propertyCardHiddenAlertCodes = [
  'no.availability.within.radius.error.msg',
  'no.hotels.within.radius.error.msg',
];

export const AMPAlertPriority = 0;
export const SERPAlertPriority = 1;
export const quickFiltersAndAmenitiesHiddenCodes = ['no.availability.within.radius.error.msg'];

export const searchFallbackWarningCodes = ['WARN-RATES-1000', 'WARN-SEARCH-1002', 'WARN-SEARCH-1009'];
export const SEARCH_FALLBACK_SERVER_ERRORS = [500, 502];
export const WARN_CODE_1000 = 'WARN-RATES-1000';
export const WARN_CODE_1001 = 'WARN-RATES-1001';
export const WARN_SEARCH_1002 = 'WARN-SEARCH-1002';
export const WARN_SEARCH_1009 = 'WARN-SEARCH-1009';
export const UXL_COMPLETE_FAIL = 'UXL Complete Failure';
export const UXL_PARTIAL_FAIL = 'UXL Partial Failure';
export const CAROUSAL_COMPATABLE_VIEWPORT = 1024;

export const ErrorFrameworkCodeArray = [
  'AMP181',
  'WARN-RATES-1000',
  'WARN-SEARCH-1002',
  'WARN-SEARCH-1009',
  'WARN-RATES-1001',
];
export const LinkMatchRegex = /<a\b[^>]*>(.*?)<\/a>/;
